import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWalkthrough } from './walkthrough-context';

export const WalkthroughCard = () => {
  const navigate = useNavigate();
  const {
    isOpen,
    currentStep,
    totalSteps,
    isFirstStep,
    isLastStep,
    state,
    nextStep,
    prevStep,
    completeWalkthrough,
    dismissWalkthrough,
    closeWalkthrough,
  } = useWalkthrough();

  if (!isOpen || !currentStep) return null;

  const handleNext = () => {
    if (isLastStep) {
      completeWalkthrough();
    } else {
      nextStep();
      const nextStepData = require('./walkthrough-steps').WALKTHROUGH_STEPS[
        state.currentStep + 1
      ];
      if (nextStepData?.path) {
        navigate(nextStepData.path);
      }
    }
  };

  const handlePrev = () => {
    prevStep();
    const prevStepData = require('./walkthrough-steps').WALKTHROUGH_STEPS[
      state.currentStep - 1
    ];
    if (prevStepData?.path) {
      navigate(prevStepData.path);
    }
  };

  const handleSkip = () => {
    dismissWalkthrough();
  };

  const progressPercent = ((state.currentStep + 1) / totalSteps) * 100;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-30 z-40"
        onClick={closeWalkthrough}
      />

      {/* Floating Card */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md">
        <div className="bg-white-main rounded-lg shadow-2xl overflow-hidden mx-4">
          {/* Progress bar */}
          <div className="h-1 bg-gray-200">
            <div
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${progressPercent}%` }}
            />
          </div>

          {/* Content */}
          <div className="p-6">
            {/* Step indicator */}
            <div className="flex items-center justify-between mb-4">
              <span className="text-xs font-medium text-gray-middle">
                Step {state.currentStep + 1} of {totalSteps}
              </span>
              <button
                onClick={handleSkip}
                className="text-xs text-gray-middle hover:text-gray-dark"
              >
                Skip tour
              </button>
            </div>

            {/* Title */}
            <h3 className="text-lg font-bold text-gray-dark mb-3">
              {currentStep.title}
            </h3>

            {/* Description */}
            <p className="text-sm text-gray-middle leading-relaxed mb-6">
              {currentStep.description}
            </p>

            {/* Navigation */}
            <div className="flex items-center justify-between">
              <button
                onClick={handlePrev}
                disabled={isFirstStep}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  isFirstStep
                    ? 'text-gray-300 cursor-not-allowed'
                    : 'text-gray-dark hover:bg-gray-100'
                }`}
              >
                Previous
              </button>

              <div className="flex gap-1">
                {Array.from({ length: totalSteps }).map((_, i) => (
                  <div
                    key={i}
                    className={`w-2 h-2 rounded-full transition-colors ${
                      i === state.currentStep
                        ? 'bg-primary'
                        : i < state.currentStep
                        ? 'bg-primary opacity-50'
                        : 'bg-gray-200'
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={handleNext}
                className="px-4 py-2 text-sm font-bold text-white-main bg-primary hover:bg-blue-hover rounded-md transition-colors"
              >
                {isLastStep ? 'Finish' : 'Next'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
